import {ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, DestroyRef, ElementRef, EventEmitter, Injectable, input, OnDestroy, Output, signal, Signal, TemplateRef, viewChild, viewChildren} from "@angular/core";
import {delayWhen, distinctUntilChanged, filter, firstValueFrom, forkJoin, from, Observable, switchMap, timer} from "rxjs";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {takeUntilDestroyed, toObservable, toSignal} from "@angular/core/rxjs-interop";
import {FormArray, FormGroup, ReactiveFormsModule, StatusChangeEvent} from "@angular/forms";
import {AgendaelementId, AvstemningsstatusModell, EntitetType, GruppeId, GruppeMedlemListeModell, MøteId, MøteModell, MøteProtokollValideringsfeil, MøteRessursClient, ProtokollDetaljerModell, ProtokollførtMøtedeltakereModell, ProtokollRessursClient, ProtokollSpesifikasjon, SkjemalåsModell, SkjemalåsRessursClient, SkjemalåsSkjemaId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MøteprotokollRedigerDeltakereKomponent} from "../møteprotokoll-rediger-deltakere/møteprotokoll-rediger-deltakere";
import {GenerertSaksreferatInformasjon, MøteprotokollRedigerSaksreferatKomponent, SkjemaType as SakSkjema} from "../møteprotokoll-rediger-saksreferat/møteprotokoll-rediger-saksreferat";
import {MøteprotokollRedigerDetaljerKontroller} from "../møteprotokoll-rediger-detaljer/møteprotokoll-rediger-detaljer";
import {tomAvstemningsstatusModell, tomMøteModell, tomProtokollTranskripsjonInformasjonModell} from "felles-ng2/modell/tommeModeller";
import {GjeldendeTidssone} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";
import {MøteDatatjeneste} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {ProtokollDatatjeneste} from "felles-ng2/tjenester/datalager/ProtokollDatatjeneste";
import {førsteVerdiLevertFraServer} from "felles-ng2/tjenester/datalager/DataOgMeta";
import {i18n, I18nTekst} from "felles-ng2/tjenester/i18n/Oversettelser";
import {MøteRedigerTidspunktKontroller} from "../../../møte/komponenter/møte-rediger-tidspunkt/møte-rediger-tidspunkt";
import {asynkArbeidPågårSignal} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {SubmitButtonKomponent} from "web-ng2/delt/komponenter/skjema/submit-button/submit-button";
import {TranslateModule} from "@ngx-translate/core";
import {RammeInnholdKomponent, RammeMedTittelKomponent} from "web-ng2/delt/komponenter/ramme-med-tittel/ramme-med-tittel";
import {InlineSkjemaKomponent} from "web-ng2/delt/komponenter/inline-skjema/inline-skjema";
import {InlineSkjemaBlokkKomponent} from "web-ng2/delt/komponenter/inline-skjema/inline-skjema-blokk/inline-skjema-blokk";
import {InlineSkjemaHandlingerKomponent} from "web-ng2/delt/komponenter/inline-skjema/inline-skjema-handlinger/inline-skjema-handlinger";
import {MatButton} from "@angular/material/button";
import {NavigasjonforhindretFlashDirektiv} from "web-ng2/delt/direktiver/navigasjonforhindret-flash/navigasjonforhindret-flash";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {erIkkeTomStreng} from "felles-ng2/støttefunksjoner/strenger";
import {TipsKomponent} from "web-ng2/delt/komponenter/tips/tips";
import {erLikeLister, nullSikkerListe} from "felles-ng2/støttefunksjoner/lister";
import {MøteprotokollSignatarer, MøteprotokollSignatarerKomponent} from "../møteprotokoll-signatarer/møteprotokoll-signatarer";
import {antallKontrollerMedFeil} from "felles-ng2/infrastruktur/angular/reactiveForm";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {map, tap} from "rxjs/operators";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {TypetValideringsresultatModell} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";
import {MøteprotokollRedigerDeltakerKomponent} from "../møteprotokoll-rediger-deltaker/møteprotokoll-rediger-deltaker";
import {NavigasjonDeaktivering} from "web-ng2/tjenester/NavigasjonDeaktivering";
import {OkResponsStatus, SkjemalåsErrorRespons, Skjemalåshåndtering, SkjemalåsOkRespons} from "felles-ng2/tjenester/Skjemalåshåndtering";
import {Appkonfigurasjon} from "felles-ng2/tjenester/Appkonfigurasjon";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {MøteprotokollRedigerBeslutningerKomponent} from "../møteprotokoll-rediger-beslutninger/møteprotokoll-rediger-beslutninger";
import {FormaterZonedDateRelativTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimeRelativPipe";
import {AsyncPipe} from "@angular/common";
import {FormaterZonedDateTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimePipe";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {fadeInnUtAnimasjon} from "web-ng2/delt/animasjoner";
import {GruppemedlemDatatjeneste} from "felles-ng2/tjenester/datalager/GruppemedlemDatatjeneste";
import {OppgaveSkjemaKomponentAvhengigheter} from "web-ng2/moduler/oppgave/komponenter/oppgave-skjema/oppgave-skjema";
import {somEntitetReferanseSpesifikasjon} from "felles-ng2/modell/entitetReferanseSpesifikasjonHjelpere";
import {MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from "@angular/material/dialog";
import {fokuserPåFørsteFeltMedFeil} from "web-ng2/delt/material/materialFormFieldHjelpere";
import {AnimationBuilder} from "@angular/animations";
import {MeldingTilBrukerNg2} from "felles-ng2/tjenester/MeldingTilBrukerNg2";
import {ToggleKlasseVedStickyDirektiv} from "web-ng2/delt/direktiver/toggleKlasseVedSticky/toggleKlasseVedSticky";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {MatIcon} from "@angular/material/icon";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {FormaterDurationPipe} from "felles-ng2/pipes/FormaterDurationPipe";
import {AgendaelementModellDLM} from "felles-ng2/tjenester/datalager/SakDatatjeneste";
import {Skedulering} from "felles-ng2/støttefunksjoner/timeout";
import {GenerertMøtereferat, GenerertSaksreferat, harTilgangTilProtokollforslag, somGenerertMøtereferat} from "felles-ng2/modell/transkripsjonModellHjelpere";
import {MøteprotokollGenererProtokollDebugDialogKomponent} from "web-ng2/moduler/møteprotokoll/modale/møteprotokoll-generer-protokoll-debug-dialog/møteprotokoll-generer-protokoll-debug-dialog";
import {dialogRespons} from "felles-ng2/infrastruktur/material/matDialogHjelpere";

const debug = initDebugger('MøteprotokollRedigerKomponent');

type SkjemaType = MøteprotokollRedigerKomponent['skjema'];
type SkjemaVerdier = SkjemaType['value'];

/**
 * Møteprotokoll
 */
@Component({
    selector: 'moeteprotokoll-rediger',
    templateUrl: 'møteprotokoll-rediger.html',
    styleUrl: 'møteprotokoll-rediger.scss',
    host: {
        'data-testid': 'møteprotokoll-rediger',
        '[attr.data-skjemalaasSistOppdatert]': 'skjemalaasSistOppdatert()' //brukes i e2e-tester
    },
    animations: [fadeInnUtAnimasjon('0.5s')],
    providers: [{provide: OppgaveSkjemaKomponentAvhengigheter, useFactory: (komponent: MøteprotokollRedigerKomponent) => komponent.oppgaveSkjemaKomponentAvhengigheter(), deps: [MøteprotokollRedigerKomponent]}],
    imports: [
        MøteprotokollRedigerDetaljerKontroller,
        MøteprotokollRedigerSaksreferatKomponent,
        MøteprotokollRedigerDeltakereKomponent,
        ReactiveFormsModule,
        SubmitButtonKomponent,
        TranslateModule,
        RammeMedTittelKomponent,
        RammeInnholdKomponent,
        InlineSkjemaKomponent,
        InlineSkjemaBlokkKomponent,
        InlineSkjemaHandlingerKomponent,
        MatButton,
        NavigasjonforhindretFlashDirektiv,
        MatMenu,
        MatMenuTrigger,
        MatMenuItem,
        TipsKomponent,
        MøteprotokollSignatarerKomponent,
        InlineMeldingKomponent,
        FormaterZonedDateRelativTimePipe,
        AsyncPipe,
        FormaterZonedDateTimePipe,
        MatProgressSpinner,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
        ToggleKlasseVedStickyDirektiv,
        HtmlFormatertKomponent,
        MatIcon,
        FormaterPlainDatePipe,
        FormaterDurationPipe
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteprotokollRedigerKomponent implements OnDestroy {
    static ajsSelector = 'moeteprotokollRediger';

    /** Antall millisekunder vi venter etter at data er lastet før vi forsøker å opprette skjemalås. Eksponert for å kunne endres i tester */
    static skjemalåsOpprettelseForsinkelse = 1000;
    /** Antall millisekunder varsel om skjemalåsoppdatering vises */
    static skjemalåsOppdateresVarselVarighet = 4 * 1000;

    private forkastGjenopprettedeEndringerDialogTemplate = viewChild.required<TemplateRef<ElementRef>>('forkastGjenopprettedeEndringerDialogTemplate');
    /** Ett saksreferatskjema per sak på møtet, i samme rekkefølge som sakene */
    private saksreferatKomponenter = viewChildren(MøteprotokollRedigerSaksreferatKomponent);

    /** Kalles når bruker har lagret (med sann som verdi) eller når bruker avbryter (med usann som verdi) */
    @Output() vedAvsluttet = new EventEmitter<boolean>(); // output<boolean>() fungerer ikke med ajs, derfor @Output()

    moeteId = input.required<MøteId>();
    /** Dersom sann vil {@link #gjenopprettFraSkjemalås} bli kalt når skjemalås opprettes og skjema allerede er låst av kallende bruker,
     * skjema gjenopprettes med data lagret i eksisterende skjemalås. */
    gjenopprettSkjema = input.required<boolean>();
    /** Dersom sann vil {@link #genererMoetereferat} bli kalt når skjema er populert, slik at referat generert fra lydopptak vises ekspandert under sakene */
    visGenerertMoetereferat = input.required<boolean>();

    lagrer = asynkArbeidPågårSignal();
    moete = signal(tomMøteModell());
    /** Sann dersom bruker ikke er skjermet for noen av sakene i møtet, se {@link harTilgangTilProtokollforslag} */
    harTilgangTilProtokollforslag = computed(() => harTilgangTilProtokollforslag(this.moete()));
    /** Sann dersom bruker har featurevalg 'ki' aktivert, kun disse har tilgang til å generere forslag til protokoll på nytt, se {@link regenererMoetereferat} */
    brukerHarKiFeature = computed(() => this.brukerkontekst.autentisertBruker().erFeatureAktivert('ki'));
    /** Sann dersom møtereferat ikke er generert og det er mulig å gjøre dette*/
    visLastGenerertMoetereferatMelding = computed(() => this.harTilgangTilProtokollforslag() && this.transkripsjonInformasjon().antallOpptak > 0 && this.transkripsjonInformasjon().antallOpptak == this.transkripsjonInformasjon().antallOpptakTranskribert && !this.transkripsjonInformasjon().oppsummertMoetereferatTilgjengelig);
    /** Sann mens referatet genereres fra lydopptakene av møtebehandlingen */
    generererMoetereferat = asynkArbeidPågårSignal();
    /** Referatet KI-en har generert fra lydopptakene, eller null før det er hentet */
    private generertMøtereferat = signal<GenerertMøtereferat | null>(null);
    /** Hva serveren har av lydopptak og transkripsjoner av møtebehandlingen, følger protokollen */
    transkripsjonInformasjon = signal(tomProtokollTranskripsjonInformasjonModell());
    /** Sann når det er gjort lydopptak av møtebehandlingen, altså når det finnes noe å generere referat fra */
    private lydopptakEksisterer = computed(() => this.transkripsjonInformasjon().antallOpptak > 0);
    /** Sann når referat er generert fra lydopptakene, uavhengig av hvilke saker genereringen ga referat for */
    private møtereferatGenerert = computed(() => this.transkripsjonInformasjon().oppsummertMoetereferatTilgjengelig);
    /**
     * Det møteopptaket ga per sak på møtet, vist som forslag over redigeringsfeltene på saken.
     *
     * Bygget som ett signal framfor et objektliteral i templaten, slik at saksreferatskjemaet får
     * samme objekt så lenge referatet er uendret – ellers ville forslaget dukket opp på nytt hver
     * gang endringsdeteksjonen kjørte, etter at bruker skjulte det.
     */
    genererteSaksreferater: Signal<ReadonlyMap<AgendaelementId, GenerertSaksreferatInformasjon>> = computed(() => {
        const lydopptakEksisterer = this.lydopptakEksisterer();
        const saksreferatGenerert = this.møtereferatGenerert();
        const saksreferater = this.generertMøtereferat()?.saker ?? new Map<AgendaelementId, GenerertSaksreferat>();
        return new Map([...saksreferater].map(([sakId, saksreferat]) => [sakId, {saksreferat, lydopptakEksisterer, saksreferatGenerert}]));
    });
    /** Det saksreferatskjemaet får for saker møteopptaket ikke ga noe referat for */
    utenGenerertSaksreferat: Signal<GenerertSaksreferatInformasjon> = computed(() =>
      ({saksreferat: null, lydopptakEksisterer: this.lydopptakEksisterer(), saksreferatGenerert: this.møtereferatGenerert()}));
    /** Saksreferatene serveren ikke knyttet til noen sak på møtet. Listes nederst i skjemaet, kun til gjennomlesning */
    genererteSaksreferaterUtenSak: Signal<GenerertSaksreferat[]> = computed(() => this.generertMøtereferat()?.utenSak ?? []);
    avstemningsstatus: Signal<AvstemningsstatusModell>;
    antallSaksbeskrivelserTilInnliming = signal(0);
    antallBeslutningsforslag = signal(0);
    signatarer = signal<MøteprotokollSignatarer>({interne: [], eksterne: []});
    antallFeil = signal(0);
    skjemalaasOkRespons = signal<SkjemalåsOkRespons | null>(null);
    skjemalaasSistOppdatert = signal<string | null>(null);
    skjemaGjenopprettet = signal<SkjemalåsModell | null>(null);
    skjemalaasErrorRespons = signal<SkjemalåsErrorRespons | null>(null);
    visSkjemalaasOppdateringPaagaar: Signal<boolean>;

    skjema = new FormGroup({
        detaljer: MøteprotokollRedigerDetaljerKontroller.opprettSkjema(),
        deltakere: MøteprotokollRedigerDeltakereKomponent.opprettSkjema(),
        saker: new FormArray<SakSkjema>([])
    });

    private skjemalåshåndtering: Skjemalåshåndtering<ProtokollSpesifikasjon>;
    private _medlemmerCachet: Promise<GruppeMedlemListeModell[]> | null = null;

    constructor(private avhengigheter: MøteprotokollRedigerKomponentAvhengigheter,
                private navigasjonDeaktivering: NavigasjonDeaktivering,
                private tidssone: GjeldendeTidssone,
                private el: ElementRef<HTMLElement>,
                private cdRef: ChangeDetectorRef,
                private animationBuilder: AnimationBuilder,
                private destroyRef: DestroyRef,
                private dialog: MatDialog,
                private melding: MeldingTilBrukerNg2,
                private brukerkontekst: BrukerkontekstTilbyder) {
        this.navigasjonDeaktivering.deaktiverNavigasjon();
        this.skjemalåshåndtering = this.avhengigheter.nySkjemalåshåndtering(() => this.somSpesifikasjon(true));
        this.visSkjemalaasOppdateringPaagaar = toSignal(this.skjemalåshåndtering.skjemalåsoppdateringPågår
          .pipe(delayWhen(pågår => timer(pågår ? 0 : MøteprotokollRedigerKomponent.skjemalåsOppdateresVarselVarighet))), {initialValue: false});

        this.avstemningsstatus = toSignal(toObservable(this.moeteId)
          .pipe(
            switchMap(id => this.avhengigheter.lastAvstemningsstatus(id)),
            takeUntilDestroyed()), {initialValue: tomAvstemningsstatusModell()});

        this.oppdaterAntallBeslutningsforslagVedEndringAvSaker();
        this.oppdaterSignatarerVedEndringAvSignaturStatus();
        this.populerSkjemaOgOpprettLås();
    }

    async genererMoetereferat(){
        await this.lastGenerertMøtereferat();
        //siden vi ikke abonnerer på endringer fra ProtokollDatatjeneste må vi selv sørge for relevant mutering her
        this.transkripsjonInformasjon.update(informasjon => ({...informasjon, oppsummertMoetereferatTilgjengelig: true}));

        this.visGenerertForslag();
    }

    limInnAlleSaksbeskrivelser() {
        this.skjema.controls.saker.controls.forEach(sakSkjema =>
          MøteprotokollRedigerSaksreferatKomponent.kopierSaksbeskrivelseTilReferat(sakSkjema));
    }

    limInnAlleBeslutningsforslag() {
        this.skjema.controls.saker.controls
          .flatMap(sak => sak.controls.beslutninger.controls.eksisterende.controls)
          .filter(beslutning => beslutning.value.erForslag)
          .forEach(forslag => forslag.controls.erForslag.setValue(false));
    }

    /**
     * Limer inn alt fra generert møtereferat: oppsummeringen bak
     * referatteksten på hver sak, og beslutningene med oppgavene sine som nye beslutninger.
     *
     * Merk at innholdet legges til, ikke erstatter det som allerede står i skjemaet.
     * Forutsetter at generertMøtereferat er lastet når denne metoden kalles.
     */
    async limInnReferatFraMoeteopptak() {
        //hvert skjema får saksreferatet serveren merket med saken skjemaet gjelder
        this.saksreferatKomponenter().forEach(saksreferatKomponent => {
            const saksreferat = this.generertMøtereferat()!.saker.get(saksreferatKomponent.skjema().value.sak!.id);
            if (erIkkeNil(saksreferat)) saksreferatKomponent.limInnAltGenerertFra(saksreferat);
        });
    }

    gaaTilFoersteFeil() {
        fokuserPåFørsteFeltMedFeil(this.el.nativeElement, this.animationBuilder);
    }

    async lagre() {
        const valideringsresultat = await this.lagrer.utfør(async () => this.avhengigheter.lagre(this.moeteId(), this.somSpesifikasjon()));
        if (valideringsresultat.harFeil) {
            valideringsresultat.feil.forEach((feil) => {
                switch (feil.feilkode) {
                    case MøteProtokollValideringsfeil.medlem_skjermet_signere:
                        const skjemafeil = {} as Record<string, boolean>;
                        skjemafeil[MøteprotokollRedigerDeltakerKomponent.valideringsfeil.skjermet_kan_ikke_signere] = true;
                        this.skjema.controls.deltakere.controls.deltakere.controls
                          .find(deltaker => deltaker.value.medlemId === feil.data.medlemId)
                          ?.controls.skalSignere.setErrors(skjemafeil);
                        break;
                    default:
                        console.warn("Ukjent feilmelding: ", feil.feilkode);
                }
            });
            return;
        }
        await this.skjemalåshåndtering.frigiSkjemalås();
        await this.navigasjonDeaktivering.reaktiverNavigasjon();
        this.vedAvsluttet.emit(true);
    }

    async avbryt() {
        if (erIkkeNil(this.skjemaGjenopprettet())) {
            //be bruker bekrefte at gjenopprettet skjema skal forkastes
            const forkast = await firstValueFrom<boolean>(this.dialog.open(this.forkastGjenopprettedeEndringerDialogTemplate(), {width: '550px'}).beforeClosed());
            if (!forkast) return;
        }
        await this.utførtAvbryt();
    }

    oppgaveSkjemaKomponentAvhengigheter(): OppgaveSkjemaKomponentAvhengigheter {
        return {
            medlemmer: gruppeId => from(this.medlemmerCachet())
        } as OppgaveSkjemaKomponentAvhengigheter
    }

    async regenererMoetereferat() {
        const oppsummering = await dialogRespons(MøteprotokollGenererProtokollDebugDialogKomponent.vis(this.dialog, this.moete().id));
        const møtereferat =  somGenerertMøtereferat(oppsummering!, this.moete().saker)
        this.generertMøtereferat.set(møtereferat);

        setTimeout(() => {
            //sørg for at generert protokoll vises ekspandert under de enkelte sakene
            this.saksreferatKomponenter().forEach(saksreferatKomponent =>
              saksreferatKomponent.visGenerertReferat());
        }, 500);
    }

    ngOnDestroy(): void {
        this.navigasjonDeaktivering.reaktiverNavigasjon();
        //sørg for at ikke asynkjobbene til skjemalåshåndtering fortsetter å kjøre dersom bruker feks bli logget ut
        this.skjemalåshåndtering.terminer();
    }


    // private hjelpemetoder

    private visGenerertForslag(){
        //siden vi ikke abonnerer på endringer fra ProtokollDatatjeneste må vi selv sørge for relevant mutering her
        this.transkripsjonInformasjon.update(informasjon => ({...informasjon, oppsummertMoetereferatTilgjengelig: true}));

        //sørg for at generert protokoll vises ekspandert under de enkelte sakene
        this.saksreferatKomponenter().forEach(saksreferatKomponent =>
          saksreferatKomponent.visGenerertReferat());

        //gå til første sak og highlight generert protokoll
        new Skedulering(100, 'scroll', this.destroyRef)
          .skeduler(() => this.saksreferatKomponenter().at(0)?.scrollTilGenerertReferat());
    }

    /**
     * Laster referat generert fra lydopptak dersom et slik har blitt generert.
     *
     * Kalles når protokollen er lastet, slik at bruker ser forslaget med en gang framfor å måtte be
     * om det selv. Referatet er allerede generert og lagret på server, så hentingen koster ingen
     * llm-kall. Hentes ikke dersom bruker er skjermet for noen av sakene i møtet, da avviser serveren kallet.
     */
    private async hentOppsummertMøtereferatDersomTilgjengelig() {
        if (!this.harTilgangTilProtokollforslag()) return;
        if (!this.transkripsjonInformasjon().oppsummertMoetereferatTilgjengelig) return;

        await this.lastGenerertMøtereferat();
        if (this.visGenerertMoetereferat()) this.visGenerertForslag();
    }

    /**
     * Referatet generert fra lydopptakene, hentet fra server og vist som forslag i skjemaet.
     *
     * Genereringen er et llm-kall som koster tid og penger, men serveren genererer bare første gang
     * og leverer den lagrede oppsummeringen etterpå – vi trenger derfor ingen cache her.
     * Returnerer et tomt referat dersom hentingen feilet, slik at neste klikk forsøker på nytt.
     */
    private async lastGenerertMøtereferat() {
        const møtereferat = await this.generererMoetereferat.utfør(() =>
          this.avhengigheter.lastGenerertMøtereferat(this.moete().id, this.moete().saker));
        this.generertMøtereferat.set(møtereferat);
    }

    private async medlemmerCachet(): Promise<GruppeMedlemListeModell[]> {
        if (erNil(this._medlemmerCachet)) this._medlemmerCachet = this.avhengigheter.medlemmer(this.moete().eiendeGruppeId);
        return this._medlemmerCachet;
    }

    private oppdaterAntallFeilVedSkjemaendringer() {
        this.skjema.events
          .pipe(
            filter(event => event instanceof StatusChangeEvent),
            map(() => antallKontrollerMedFeil(this.skjema)),
            takeUntilDestroyed(this.destroyRef))
          .subscribe(antall => this.antallFeil.set(antall))
    }

    private oppdaterSignatarerVedEndringAvSignaturStatus() {
        this.skjema.controls.deltakere.valueChanges
          .pipe(
            distinctUntilChanged(erLikeLister, deltakere => [...deltakere.deltakere!, ...deltakere.eksterneDeltakere!].map(deltaker => deltaker.skalSignere!)),
            takeUntilDestroyed())
          .subscribe(deltakere =>
            this.signatarer.set({
                interne: deltakere.deltakere!.filter(deltaker => deltaker.skalSignere).map(deltaker => deltaker.deltaker!),
                eksterne: deltakere.eksterneDeltakere!.filter(deltaker => deltaker.skalSignere).map(deltaker => ({navn: deltaker.navn!, rolle: deltaker.rolle!, kommentar: deltaker.kommentar!}))
            }));
    }

    private oppdaterAntallBeslutningsforslagVedEndringAvSaker() {
        this.skjema.controls.saker.valueChanges
          .pipe(
            //dersom alle innslagene i FormArray er disabled vil også FormArray være disabled, og da returnerer FormArray.value undefined
            map(saker => saker.flatMap(sak => nullSikkerListe(sak.beslutninger!.eksisterende)).filter(beslutning => beslutning.erForslag).length),
            distinctUntilChanged(),
            takeUntilDestroyed(this.destroyRef))
          .subscribe(antallForslag => this.antallBeslutningsforslag.set(antallForslag))
    }

    private populerSkjemaOgOpprettLås() {
        toObservable(this.moeteId)
          .pipe(
            //last data som kreves for å populere skjema, vent til alle ressurser har levert
            switchMap(id => forkJoin([
                //merk at vi her ikke abonnerer på en strøm av oppdateringer, kun laster data fra server én gang, slik at ikke skjema blir resatt som følge av push av endringshendelser fra server
                //muteringer av ProtokollDetaljerModell.transkripsjonInformasjon håndterer vi manuelt i genererMoetereferat(..)
                this.avhengigheter.lastProtokoll(id).then(protokoll => {
                    this.transkripsjonInformasjon.set(protokoll.transkripsjonInformasjon);
                    MøteprotokollRedigerDetaljerKontroller.populerSkjema(this.skjema.controls.detaljer, protokoll, this.tidssone.brukersTidssone());
                }),
                this.avhengigheter.lastProtokollførtMøtedeltakere(id).then(deltakere =>
                  MøteprotokollRedigerDeltakereKomponent.populerSkjema(this.skjema.controls.deltakere, deltakere)),
                this.avhengigheter.lastMøte(id).then(møte =>
                  this.populerSkjemaMedMøtedata(møte))
            ])),
            //oppdater antall feil ved skjemaendringer - bør ikke gjøres før skjema har blitt fullt populert, derfor her...
            tap(() => this.oppdaterAntallFeilVedSkjemaendringer()),
            //har serveren allerede oppsummert opptakene skal forslaget hentes uten at bruker må be om det
            tap(() => this.hentOppsummertMøtereferatDersomTilgjengelig()),
            //opprett skjemalås og start periodisk oppdatering av denne
            //merk at vi forventer at møteIdObs ikke leverer forskjellige verdier - da vil i så fall ikke skjemlåsene bli frigitt
            switchMap(() => this.opprettSkjemalås()),
            takeUntilDestroyed())
          .subscribe({
              next: skjemalåsrespons => {
                  this.skjemalaasOkRespons.set(skjemalåsrespons);
                  this.skjemalaasSistOppdatert.set(skjemalåsrespons.laas.oppdatertDato);
                  if (skjemalåsrespons.status == OkResponsStatus.ingenEndringerLåsOvertatt)
                      this.gjenopprettFraSkjemalås(skjemalåsrespons);

              },
              error: feil => {
                  if (feil instanceof SkjemalåsErrorRespons)
                    this.skjemalaasErrorRespons.set(feil);
                  else
                      this.melding.feilmelding(new I18nTekst(i18n('En feil oppstod under sikkerhetskopierering av skjema')));
                  
              }
          });
    }

    private opprettSkjemalås(): Observable<SkjemalåsOkRespons> {
        return this.skjemalåshåndtering.opprettSkjemalåsForsinket(
          this.moete().eiendeGruppeId,
          somEntitetReferanseSpesifikasjon(EntitetType.møte, this.moete().id),
          this.gjenopprettSkjema(),
          MøteprotokollRedigerKomponent.skjemalåsOpprettelseForsinkelse)
    }

    private populerSkjemaMedMøtedata(møte: MøteModell) {
        this.moete.set(møte);
        this.skjema.controls.saker.clear();
        møte.saker
          .filter(sak => !sak.erPause)
          .forEach(sak =>
            this.skjema.controls.saker.push(MøteprotokollRedigerSaksreferatKomponent.populerSkjema(MøteprotokollRedigerSaksreferatKomponent.opprettSkjema(), sak)));
        //FormArray.push (og øvrige metoder på FormArray) trigger ikke rendering - må derfor manuelt signalisere at det har skjedd endringer som skal tegnes ut
        this.cdRef.markForCheck();

        this.antallSaksbeskrivelserTilInnliming.set(møte.saker.filter(sak => erIkkeTomStreng(sak.beskrivelse)).length);
    }

    /** Returnerer skjema som spesifikasjon.
     * Dersom brukOpprinneligMøtedatoDersomSkjemUgyldig=true vil møtets opprinnelige dato bli brukt for å unngå ugyldige data -for bruk ifbm sikkerhetskopiering av skjema ifbm Skjemalåshåndtering.
     * public for testbarhet */
    somSpesifikasjon(brukOpprinneligMøtedatoDersomSkjemUgyldig = false): ProtokollSpesifikasjon {
        //må bruke getRawValue ellers blir ikke slettede beslutninger/oppgaver inkludert (disse har blitt markert som disabled - og blir derfor ikke inkludert i skjema.value)
        const skjemaverdier = this.skjema.getRawValue();
        let sikkerDato = brukOpprinneligMøtedatoDersomSkjemUgyldig && this.skjema.controls.detaljer.controls.tidspunkt.invalid ?
          this.moete().dato : //anser det som ok å bruker møte.dato og ikke protokoll.dato her
          MøteRedigerTidspunktKontroller.somMøteDato2(skjemaverdier.detaljer!.tidspunkt!, this.tidssone.brukersTidssone()).somSerialiserbar();
        return {
            dato: sikkerDato,
            behandlingsMaate: skjemaverdier.detaljer!.behandlingsmaate!,
            behandlingsSted: skjemaverdier.detaljer!.moetested!,
            ...MøteprotokollRedigerDeltakereKomponent.somSpesifikasjon(skjemaverdier.deltakere!),
            saker: skjemaverdier.saker!.map(sak => MøteprotokollRedigerSaksreferatKomponent.somSpesifikasjon(sak))
        };
    }

    private async gjenopprettFraSkjemalås(skjemalåsrespons: SkjemalåsOkRespons) {
        debug("gjenopprettFraSkjemalaas", skjemalåsrespons)
        this.skjemaGjenopprettet.set(skjemalåsrespons.laas);
        const medlemmer = await this.medlemmerCachet();
        const skjemaverdier = skjemalåsrespons.laas.skjema as ProtokollSpesifikasjon
        MøteprotokollRedigerDetaljerKontroller.gjenopprettSkjema(this.skjema.controls.detaljer, skjemaverdier, this.tidssone.brukersTidssone());
        MøteprotokollRedigerDeltakereKomponent.gjenopprettSkjema(this.skjema.controls.deltakere, skjemaverdier)
        skjemaverdier.saker.forEach(gjenopprettetSak => {
            const eksisterendeSak = this.skjema.controls.saker.controls.find(kandidat => kandidat.value.sak!.id == gjenopprettetSak.sakId);
            if (erNil(eksisterendeSak)) {
                debug("gjenopprettFraSkjema - finner ikke tilsvarende sak") //@todo
                return;
            }
            eksisterendeSak.patchValue({referat: gjenopprettetSak.referat});
            MøteprotokollRedigerBeslutningerKomponent.gjenopprettBeslutningSkjema(eksisterendeSak.controls.beslutninger, gjenopprettetSak.beslutninger, medlemmer);
        });
    }

    private async utførtAvbryt() {
        await this.skjemalåshåndtering.frigiSkjemalås();
        await this.navigasjonDeaktivering.reaktiverNavigasjon();
        this.vedAvsluttet.emit(false);
    }
}

@Injectable()
export class MøteprotokollRedigerKomponentAvhengigheter {

    constructor(private møteDatatjeneste: MøteDatatjeneste,
                private protokollDatatjeneste: ProtokollDatatjeneste,
                private protokollRessurs: ProtokollRessursClient,
                private møteRessurs: MøteRessursClient,
                private skjemalåsRessurs: SkjemalåsRessursClient,
                private gruppemedlemDatatjeneste: GruppemedlemDatatjeneste,
                private konfigurasjon: Appkonfigurasjon) {
    }

    lastMøte(id: MøteId): Promise<MøteModell> {
        return førsteVerdiLevertFraServer(this.møteDatatjeneste.hentMedMeta(id));
    }

    lastProtokoll(id: MøteId): Promise<ProtokollDetaljerModell> {
        return førsteVerdiLevertFraServer(this.protokollDatatjeneste.hentMedMeta(id));
    }

    lastProtokollførtMøtedeltakere(id: MøteId): Promise<ProtokollførtMøtedeltakereModell> {
        return this.protokollRessurs.deltakere(id).somPromiseVisMeldingVedFeil(i18n('Kunne ikke hente protokollførte møtedeltakere'));
    }

    lastAvstemningsstatus(id: MøteId): Promise<AvstemningsstatusModell> {
        return this.møteRessurs.avstemningsstatus(id).somPromiseVisMeldingVedFeil(i18n('Kunne ikke hente avstemningsstatus'));
    }

    lastGenerertMøtereferat(møteId: MøteId, saker: AgendaelementModellDLM[]): Promise<GenerertMøtereferat> {
        return this.protokollDatatjeneste.genererSaksreferaterFraOpptak(møteId, saker);
    }

    medlemmer(gruppeId: GruppeId): Promise<GruppeMedlemListeModell[]> {
        return førsteVerdiLevertFraServer(this.gruppemedlemDatatjeneste.finnTilgjengeligeMedMeta(gruppeId));
    }

    nySkjemalåshåndtering(skjemaspesifikasjon: () => ProtokollSpesifikasjon): Skjemalåshåndtering<ProtokollSpesifikasjon> {
        return new Skjemalåshåndtering<ProtokollSpesifikasjon>(skjemaspesifikasjon, SkjemalåsSkjemaId.moeteprotokoll, this.konfigurasjon.klientId, this.skjemalåsRessurs);
    }

    lagre(id: MøteId, spesifikasjon: ProtokollSpesifikasjon): Promise<TypetValideringsresultatModell<MøteProtokollValideringsfeil>> {
        // @ts-ignore
        return this.protokollRessurs.oppdaterProtokoll(id, spesifikasjon).somPromiseVisMeldingVedFeil(i18n('Kunne ikke lagre protokoll'));
    }
}

